// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tonyte-web-loader {
  position: relative;
  display: grid;
  width: 100%;
  height: 100%;
  min-height: 100dvh;
  place-items: center;
  overflow: hidden;
  color: #eef2f7;
  background: linear-gradient(155deg, #0b1826 0%, #070b14 48%, #020409 100%);
  isolation: isolate;
}

.tonyte-web-loader__background,
.tonyte-web-loader__wash,
.tonyte-web-loader__aura {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.tonyte-web-loader__wash {
  width: min(62vw, 840px);
  height: min(62vw, 840px);
  margin: auto;
  border-radius: 50%;
  opacity: 0.11;
  will-change: transform, opacity;
}

.tonyte-web-loader__wash--orange {
  background: radial-gradient(circle, rgba(255, 136, 45, 0.32), transparent 68%);
  animation: tonyte-loader-wash-orange 12s ease-in-out infinite alternate;
}

.tonyte-web-loader__wash--purple {
  background: radial-gradient(circle, rgba(139, 92, 246, 0.24), transparent 68%);
  animation: tonyte-loader-wash-purple 15s ease-in-out infinite alternate;
}

.tonyte-web-loader__content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 24px;
}

.tonyte-web-loader__logo-stage {
  position: relative;
  display: grid;
  width: clamp(190px, 24vw, 260px);
  height: clamp(190px, 24vw, 260px);
  place-items: center;
}

.tonyte-web-loader__aura {
  margin: auto;
  border-radius: 50%;
  will-change: transform, opacity;
}

.tonyte-web-loader__aura--orange {
  width: 86%;
  height: 86%;
  background: radial-gradient(circle, rgba(255, 154, 60, 0.42) 0%, rgba(242, 125, 38, 0.13) 42%, transparent 70%);
  animation: tonyte-loader-aura 2.8s ease-in-out infinite;
}

.tonyte-web-loader__aura--purple {
  width: 100%;
  height: 100%;
  background: radial-gradient(circle, rgba(153, 106, 255, 0.18), transparent 66%);
  animation: tonyte-loader-aura-secondary 3.7s ease-in-out infinite;
}

.tonyte-web-loader__logo {
  position: relative;
  width: clamp(96px, 11vw, 126px);
  height: auto;
  object-fit: contain;
  opacity: 0.99;
  filter: drop-shadow(0 12px 30px rgba(0, 0, 0, 0.34));
  animation: tonyte-loader-logo 2.8s ease-in-out infinite;
  will-change: transform;
}

.tonyte-web-loader__message {
  display: flex;
  min-width: min(82vw, 310px);
  justify-content: center;
  margin-top: 12px;
  color: rgba(238, 242, 247, 0.72);
  font-size: clamp(0.9rem, 1.5vw, 1rem);
  font-weight: 500;
  letter-spacing: 0.02em;
  line-height: 1.4;
  text-align: center;
}

.tonyte-web-loader__message-copy {
  animation: tonyte-loader-message-in 320ms ease-out both;
}

.tonyte-web-loader__message-dots {
  display: inline-flex;
  width: 1.65em;
  flex: 0 0 1.65em;
  justify-content: flex-start;
  text-align: left;
}

.tonyte-web-loader__message-dots span,
.tonyte-web-loader__activity span {
  animation: tonyte-loader-dot 1.35s ease-in-out infinite;
}

.tonyte-web-loader__message-dots span:nth-child(2),
.tonyte-web-loader__activity span:nth-child(2) { animation-delay: 180ms; }

.tonyte-web-loader__message-dots span:nth-child(3),
.tonyte-web-loader__activity span:nth-child(3) { animation-delay: 360ms; }

.tonyte-web-loader__activity {
  display: flex;
  gap: 8px;
  margin-top: 17px;
}

.tonyte-web-loader__activity span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #ff913d;
  box-shadow: 0 0 12px rgba(255, 133, 48, 0.62);
}

.tonyte-web-loader__activity span:nth-child(2) {
  background: #c28aff;
  box-shadow: 0 0 12px rgba(170, 116, 255, 0.55);
}

.tonyte-web-loader__star {
  position: absolute;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: rgba(255, 230, 207, 0.65);
  animation: tonyte-loader-star 5.5s ease-in-out infinite alternate;
  will-change: transform, opacity;
}

.tonyte-web-loader__star--1 { top: 18%; left: 21%; animation-delay: -1s; }
.tonyte-web-loader__star--2 { top: 27%; right: 19%; animation-delay: -3.2s; }
.tonyte-web-loader__star--3 { top: 67%; left: 14%; animation-delay: -4.1s; }
.tonyte-web-loader__star--4 { top: 74%; right: 17%; animation-delay: -2.2s; }
.tonyte-web-loader__star--5 { top: 43%; left: 32%; animation-delay: -0.4s; }
.tonyte-web-loader__star--6 { top: 38%; right: 29%; animation-delay: -4.8s; }
.tonyte-web-loader__star--7 { top: 84%; left: 47%; animation-delay: -2.8s; }

@keyframes tonyte-loader-logo {
  0%, 100% { transform: translate3d(0, 2px, 0) scale(1); }
  50% { transform: translate3d(0, -4px, 0) scale(1.035); }
}

@keyframes tonyte-loader-aura {
  0%, 100% { opacity: 0.48; transform: scale(0.93); }
  50% { opacity: 0.9; transform: scale(1.08); }
}

@keyframes tonyte-loader-aura-secondary {
  0%, 100% { opacity: 0.24; transform: scale(1.02); }
  50% { opacity: 0.58; transform: scale(0.92); }
}

@keyframes tonyte-loader-dot {
  0%, 70%, 100% { opacity: 0.25; transform: translateY(0) scale(0.82); }
  35% { opacity: 1; transform: translateY(-3px) scale(1); }
}

@keyframes tonyte-loader-star {
  from { opacity: 0.18; transform: translate3d(0, 4px, 0); }
  to { opacity: 0.7; transform: translate3d(5px, -7px, 0); }
}

@keyframes tonyte-loader-wash-orange {
  from { opacity: 0.08; transform: translate3d(-12%, 5%, 0) scale(0.9); }
  to { opacity: 0.14; transform: translate3d(10%, -4%, 0) scale(1.08); }
}

@keyframes tonyte-loader-wash-purple {
  from { opacity: 0.07; transform: translate3d(13%, -8%, 0) scale(1.06); }
  to { opacity: 0.13; transform: translate3d(-10%, 7%, 0) scale(0.92); }
}

@keyframes tonyte-loader-message-in {
  from { opacity: 0; transform: translateY(3px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (max-width: 600px) {
  .tonyte-web-loader__logo-stage { width: 190px; height: 190px; }
  .tonyte-web-loader__logo { width: 96px; }
}

@media (prefers-reduced-motion: reduce) {
  .tonyte-web-loader__logo,
  .tonyte-web-loader__aura,
  .tonyte-web-loader__wash,
  .tonyte-web-loader__star,
  .tonyte-web-loader__message-copy {
    animation: none;
  }

  .tonyte-web-loader__aura--orange { opacity: 0.62; }
  .tonyte-web-loader__aura--purple { opacity: 0.32; }
  .tonyte-web-loader__message-dots span,
  .tonyte-web-loader__activity span {
    animation-duration: 2.1s;
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TonyteLoadingScreen.web.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,0EAA0E;EAC1E,kBAAkB;AACpB;;AAEA;;;EAGE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,8EAA8E;EAC9E,uEAAuE;AACzE;;AAEA;EACE,8EAA8E;EAC9E,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,+GAA+G;EAC/G,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+EAA+E;EAC/E,iEAAiE;AACnE;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,oDAAoD;EACpD,uDAAuD;EACvD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;EAEE,uDAAuD;AACzD;;AAEA;iDACiD,sBAAsB,EAAE;;AAEzE;iDACiD,sBAAsB,EAAE;;AAEzE;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,iEAAiE;EACjE,+BAA+B;AACjC;;AAEA,8BAA8B,QAAQ,EAAE,SAAS,EAAE,oBAAoB,EAAE;AACzE,8BAA8B,QAAQ,EAAE,UAAU,EAAE,sBAAsB,EAAE;AAC5E,8BAA8B,QAAQ,EAAE,SAAS,EAAE,sBAAsB,EAAE;AAC3E,8BAA8B,QAAQ,EAAE,UAAU,EAAE,sBAAsB,EAAE;AAC5E,8BAA8B,QAAQ,EAAE,SAAS,EAAE,sBAAsB,EAAE;AAC3E,8BAA8B,QAAQ,EAAE,UAAU,EAAE,sBAAsB,EAAE;AAC5E,8BAA8B,QAAQ,EAAE,SAAS,EAAE,sBAAsB,EAAE;;AAE3E;EACE,WAAW,0CAA0C,EAAE;EACvD,MAAM,+CAA+C,EAAE;AACzD;;AAEA;EACE,WAAW,aAAa,EAAE,sBAAsB,EAAE;EAClD,MAAM,YAAY,EAAE,sBAAsB,EAAE;AAC9C;;AAEA;EACE,WAAW,aAAa,EAAE,sBAAsB,EAAE;EAClD,MAAM,aAAa,EAAE,sBAAsB,EAAE;AAC/C;;AAEA;EACE,gBAAgB,aAAa,EAAE,oCAAoC,EAAE;EACrE,MAAM,UAAU,EAAE,oCAAoC,EAAE;AAC1D;;AAEA;EACE,OAAO,aAAa,EAAE,iCAAiC,EAAE;EACzD,KAAK,YAAY,EAAE,oCAAoC,EAAE;AAC3D;;AAEA;EACE,OAAO,aAAa,EAAE,8CAA8C,EAAE;EACtE,KAAK,aAAa,EAAE,+CAA+C,EAAE;AACvE;;AAEA;EACE,OAAO,aAAa,EAAE,+CAA+C,EAAE;EACvE,KAAK,aAAa,EAAE,+CAA+C,EAAE;AACvE;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,iCAAiC,YAAY,EAAE,aAAa,EAAE;EAC9D,2BAA2B,WAAW,EAAE;AAC1C;;AAEA;EACE;;;;;IAKE,eAAe;EACjB;;EAEA,mCAAmC,aAAa,EAAE;EAClD,mCAAmC,aAAa,EAAE;EAClD;;IAEE,wBAAwB;IACxB,eAAe;EACjB;AACF","sourcesContent":[".tonyte-web-loader {\n  position: relative;\n  display: grid;\n  width: 100%;\n  height: 100%;\n  min-height: 100dvh;\n  place-items: center;\n  overflow: hidden;\n  color: #eef2f7;\n  background: linear-gradient(155deg, #0b1826 0%, #070b14 48%, #020409 100%);\n  isolation: isolate;\n}\n\n.tonyte-web-loader__background,\n.tonyte-web-loader__wash,\n.tonyte-web-loader__aura {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n\n.tonyte-web-loader__wash {\n  width: min(62vw, 840px);\n  height: min(62vw, 840px);\n  margin: auto;\n  border-radius: 50%;\n  opacity: 0.11;\n  will-change: transform, opacity;\n}\n\n.tonyte-web-loader__wash--orange {\n  background: radial-gradient(circle, rgba(255, 136, 45, 0.32), transparent 68%);\n  animation: tonyte-loader-wash-orange 12s ease-in-out infinite alternate;\n}\n\n.tonyte-web-loader__wash--purple {\n  background: radial-gradient(circle, rgba(139, 92, 246, 0.24), transparent 68%);\n  animation: tonyte-loader-wash-purple 15s ease-in-out infinite alternate;\n}\n\n.tonyte-web-loader__content {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 32px 24px;\n}\n\n.tonyte-web-loader__logo-stage {\n  position: relative;\n  display: grid;\n  width: clamp(190px, 24vw, 260px);\n  height: clamp(190px, 24vw, 260px);\n  place-items: center;\n}\n\n.tonyte-web-loader__aura {\n  margin: auto;\n  border-radius: 50%;\n  will-change: transform, opacity;\n}\n\n.tonyte-web-loader__aura--orange {\n  width: 86%;\n  height: 86%;\n  background: radial-gradient(circle, rgba(255, 154, 60, 0.42) 0%, rgba(242, 125, 38, 0.13) 42%, transparent 70%);\n  animation: tonyte-loader-aura 2.8s ease-in-out infinite;\n}\n\n.tonyte-web-loader__aura--purple {\n  width: 100%;\n  height: 100%;\n  background: radial-gradient(circle, rgba(153, 106, 255, 0.18), transparent 66%);\n  animation: tonyte-loader-aura-secondary 3.7s ease-in-out infinite;\n}\n\n.tonyte-web-loader__logo {\n  position: relative;\n  width: clamp(96px, 11vw, 126px);\n  height: auto;\n  object-fit: contain;\n  opacity: 0.99;\n  filter: drop-shadow(0 12px 30px rgba(0, 0, 0, 0.34));\n  animation: tonyte-loader-logo 2.8s ease-in-out infinite;\n  will-change: transform;\n}\n\n.tonyte-web-loader__message {\n  display: flex;\n  min-width: min(82vw, 310px);\n  justify-content: center;\n  margin-top: 12px;\n  color: rgba(238, 242, 247, 0.72);\n  font-size: clamp(0.9rem, 1.5vw, 1rem);\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  line-height: 1.4;\n  text-align: center;\n}\n\n.tonyte-web-loader__message-copy {\n  animation: tonyte-loader-message-in 320ms ease-out both;\n}\n\n.tonyte-web-loader__message-dots {\n  display: inline-flex;\n  width: 1.65em;\n  flex: 0 0 1.65em;\n  justify-content: flex-start;\n  text-align: left;\n}\n\n.tonyte-web-loader__message-dots span,\n.tonyte-web-loader__activity span {\n  animation: tonyte-loader-dot 1.35s ease-in-out infinite;\n}\n\n.tonyte-web-loader__message-dots span:nth-child(2),\n.tonyte-web-loader__activity span:nth-child(2) { animation-delay: 180ms; }\n\n.tonyte-web-loader__message-dots span:nth-child(3),\n.tonyte-web-loader__activity span:nth-child(3) { animation-delay: 360ms; }\n\n.tonyte-web-loader__activity {\n  display: flex;\n  gap: 8px;\n  margin-top: 17px;\n}\n\n.tonyte-web-loader__activity span {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #ff913d;\n  box-shadow: 0 0 12px rgba(255, 133, 48, 0.62);\n}\n\n.tonyte-web-loader__activity span:nth-child(2) {\n  background: #c28aff;\n  box-shadow: 0 0 12px rgba(170, 116, 255, 0.55);\n}\n\n.tonyte-web-loader__star {\n  position: absolute;\n  width: 3px;\n  height: 3px;\n  border-radius: 50%;\n  background: rgba(255, 230, 207, 0.65);\n  animation: tonyte-loader-star 5.5s ease-in-out infinite alternate;\n  will-change: transform, opacity;\n}\n\n.tonyte-web-loader__star--1 { top: 18%; left: 21%; animation-delay: -1s; }\n.tonyte-web-loader__star--2 { top: 27%; right: 19%; animation-delay: -3.2s; }\n.tonyte-web-loader__star--3 { top: 67%; left: 14%; animation-delay: -4.1s; }\n.tonyte-web-loader__star--4 { top: 74%; right: 17%; animation-delay: -2.2s; }\n.tonyte-web-loader__star--5 { top: 43%; left: 32%; animation-delay: -0.4s; }\n.tonyte-web-loader__star--6 { top: 38%; right: 29%; animation-delay: -4.8s; }\n.tonyte-web-loader__star--7 { top: 84%; left: 47%; animation-delay: -2.8s; }\n\n@keyframes tonyte-loader-logo {\n  0%, 100% { transform: translate3d(0, 2px, 0) scale(1); }\n  50% { transform: translate3d(0, -4px, 0) scale(1.035); }\n}\n\n@keyframes tonyte-loader-aura {\n  0%, 100% { opacity: 0.48; transform: scale(0.93); }\n  50% { opacity: 0.9; transform: scale(1.08); }\n}\n\n@keyframes tonyte-loader-aura-secondary {\n  0%, 100% { opacity: 0.24; transform: scale(1.02); }\n  50% { opacity: 0.58; transform: scale(0.92); }\n}\n\n@keyframes tonyte-loader-dot {\n  0%, 70%, 100% { opacity: 0.25; transform: translateY(0) scale(0.82); }\n  35% { opacity: 1; transform: translateY(-3px) scale(1); }\n}\n\n@keyframes tonyte-loader-star {\n  from { opacity: 0.18; transform: translate3d(0, 4px, 0); }\n  to { opacity: 0.7; transform: translate3d(5px, -7px, 0); }\n}\n\n@keyframes tonyte-loader-wash-orange {\n  from { opacity: 0.08; transform: translate3d(-12%, 5%, 0) scale(0.9); }\n  to { opacity: 0.14; transform: translate3d(10%, -4%, 0) scale(1.08); }\n}\n\n@keyframes tonyte-loader-wash-purple {\n  from { opacity: 0.07; transform: translate3d(13%, -8%, 0) scale(1.06); }\n  to { opacity: 0.13; transform: translate3d(-10%, 7%, 0) scale(0.92); }\n}\n\n@keyframes tonyte-loader-message-in {\n  from { opacity: 0; transform: translateY(3px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@media (max-width: 600px) {\n  .tonyte-web-loader__logo-stage { width: 190px; height: 190px; }\n  .tonyte-web-loader__logo { width: 96px; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .tonyte-web-loader__logo,\n  .tonyte-web-loader__aura,\n  .tonyte-web-loader__wash,\n  .tonyte-web-loader__star,\n  .tonyte-web-loader__message-copy {\n    animation: none;\n  }\n\n  .tonyte-web-loader__aura--orange { opacity: 0.62; }\n  .tonyte-web-loader__aura--purple { opacity: 0.32; }\n  .tonyte-web-loader__message-dots span,\n  .tonyte-web-loader__activity span {\n    animation-duration: 2.1s;\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
